// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"5583": "e07dd7e6","7916": "1d381851","8457": "790bc4bf",}[chunkId] + ".css"
}